import { IFirstPaymentDefinition } from '@entities/firstPaymentDefinition';

export default function (
    firstPaymentDefinitions: IFirstPaymentDefinition[] | null,
    selectedPrepayments: number[],
): boolean {
    if (!selectedPrepayments.length) return true;
    if (!firstPaymentDefinitions || !firstPaymentDefinitions.length) return false;
    return firstPaymentDefinitions.some((fpd) => {
        const percentValue = Math.round(fpd.firstPaymentPart * 100);
        return selectedPrepayments.includes(percentValue);
    });
}
